export default __webpack_public_path__ + "static/media/neang_titya.79aed5e7.jpg";